import { EditarDocumento, GerarDoc, SalvarEGerarDocumento } from "services/CallAPIs"
import { userHasAccess, userLogado } from "services/LoginFunctions"
import { criarDocBodyInterno, criarDocBodyBDFromGuia } from "models/BodyDocumentosBD"
import { fillInputWithCache } from "services/FormFunctions"

import { ROLE } from "constants/userRoles"
import { TIPO, TIPONOME, SUBTIPONOME, SUBTIPO } from "constants/tiposDoc"
import { ErrorAutenticacao, ErrorChamadaApi, ErrorProcessoNaoAssociado, ErrorUsuarioNaoLogado } from "hooks/useAlert"

export function idDocToNome(idTipo, idSubTipo)
{
    return TIPONOME[idTipo] + (idSubTipo ? ` - ${SUBTIPONOME[idSubTipo]}` : "")
}

export function docValido(tipoDoc, subTipoDoc)
{
    if (!Object.keys(TIPO).includes(tipoDoc)) { return false }
    if (docTemSubtipo(tipoDoc) && !Object.keys(SUBTIPO).includes(subTipoDoc)) { return false }

    return true
}

function docTemSubtipo(tipoDoc)
{
    const docsComSubTipo = [TIPO.Alvara, TIPO.Anuencia, TIPO.CertDemol, TIPO.CertRegul]
    return docsComSubTipo.includes(tipoDoc)
}

function fileName(nameServ)
{
    const todayDate = new Date()
    return nameServ + " - " + todayDate.getDate() + "_" + (todayDate.getMonth() + 1) + "_" + todayDate.getFullYear()
}

function stringToBool(docData)
{
    const allFields = document.getElementsByTagName("input")
    for (let i = 0 ; i <= allFields.length - 1 ; i += 1)
    {
        if (allFields[i].type !== "checkbox") { continue }

        const inputName = allFields[i].name
        docData[inputName] = docData[inputName] && (docData[inputName] === "true" || docData[inputName] === "on") ? true : false
    }
}

export function autoFillWithCache(tipoDoc, subTipoDoc, setAmountGroupFields, setShowAlertNoData, setShowAlertDataLoaded)
{
    if (localStorage.getItem("TipoDocSaved-") !== tipoDoc) { setShowAlertNoData(true) ; return }
    if (subTipoDoc && localStorage.getItem("SubTipoDocSaved-") !== subTipoDoc) { setShowAlertNoData(true) ; return }

    fillInputWithCache()
    setShowAlertDataLoaded(true)
}

function docIsInterno(tipoDoc, subTipoDoc) { return tipoDoc === "DirDrenagem" && subTipoDoc === null}

export function ChecarCondicoesAntesEnviar(idProc, numProc, anoProc)
{
    if (!userLogado)
    {
        return ErrorUsuarioNaoLogado()
    }
    if (!userHasAccess(ROLE.ANALISTA))
    {
        return ErrorAutenticacao()
    }
    if (!idProc && !numProc && !anoProc)
    {
        return ErrorProcessoNaoAssociado()
    }

    return null
}

export async function ChamarGerador(tipoDoc, subTipoDoc, formData, guiaData, dadosDoc, editar, numProc, anoProc, idProc, idDoc, salvarDoc)
{
    let nameServ = idDocToNome(tipoDoc, subTipoDoc)
    stringToBool(formData)
    const docBody = docIsInterno(tipoDoc, subTipoDoc)
                    ? criarDocBodyInterno(nameServ, tipoDoc, subTipoDoc, formData)
                    : criarDocBodyBDFromGuia(tipoDoc, subTipoDoc, guiaData, dadosDoc, formData)
                    
    try
    {
        if (!editar)
        {
            // if (salvarDoc)
            // {
            //     await SalvarDocumento(numProc, anoProc, docBody, true)
            // }

            // const fileName = TIPONOME[tipoDoc] + " - " + subTipoDoc + " - Proc n° " + numProc
            // const response = await GerarDoc(docBody, fileName, numProc, anoProc, true, undefined)

            const fileName = TIPONOME[tipoDoc] + " - " + subTipoDoc + " - Proc n° " + numProc
            if (salvarDoc)
            {                
                await SalvarEGerarDocumento(numProc, anoProc, docBody, fileName)
            }
            else
            {
                await GerarDoc(docBody, fileName, numProc, anoProc, true, undefined)
            }
            
            // response.blob().then(data => downloadDocument(data, fileName(nameServ)))
        }
        else
        {
            if (salvarDoc)
            {
                await EditarDocumento(idProc, idDoc, docBody, fileName(nameServ))
            }
        }


        return {
            "header": "Seu documento foi gerado com sucesso!", 
            "body": "O pdf será baixado automaticamente em uma nova aba.", 
            "variant": "success"
        }
    }
    catch(error)
    {
        console.log("error")
        console.log(error)
        return ErrorChamadaApi("gerador de documentos", error.message)
    }
}